import { useIntl } from "react-intl";
import { themedUseStyletron } from "../../../../theme/customTheme";
import { ValueDisplayWithLabel } from "../../../components/ValueDisplay";
import { TScheduler } from "../types";
import { getValue } from "../utils";

export const StateText = (props: TScheduler) => {
    const intl = useIntl();
    const [css, theme] = themedUseStyletron();

  
    const fg = props.isOn ? theme.appColors.aggregate.on : theme.appColors.aggregate.off;
    const hasStateText = props.currentStateText ? true : false;
    const hasValue = props.value !== undefined && props.value !== null;



    if (!hasValue)
        return (<ValueDisplayWithLabel color={fg} label={intl.formatMessage({ id: "Scheduler.Current", defaultMessage: "currently" })} small value={'NULL'}></ValueDisplayWithLabel>);
    if (hasStateText)
        return (<ValueDisplayWithLabel color={fg} label={intl.formatMessage({ id: "Scheduler.Current", defaultMessage: "currently" })} small value={props.currentStateText || 'error'}></ValueDisplayWithLabel>)

    return (
        <ValueDisplayWithLabel color={fg} label={intl.formatMessage({ id: "Scheduler.Current", defaultMessage: "currently" })} small value={getValue(props.dataType, props.value) ?? 'NULL'}></ValueDisplayWithLabel>
    )
}